import { Grid } from '@mui/material';
import React from 'react';
import { DealTableCounterCard } from '@/components/tables/DealCardCount';

export const KanbanViewKPIHeader = ({ pipelineId }) => {
	const kpiTypes = ['In Progress', 'Conversion', 'Invoiced', 'Total'];
	const getCountType = (type) => {
		switch (type) {
			case 'In Progress':
				return 'inProgressDealAmount';
			case 'Conversion':
				return 'conversionDealAmount';
			case 'Invoiced':
				return 'invoicedDealAmount';
			case 'Total':
				return 'totalDealAmount';
			default:
				return `${type.toLowerCase().replace(' ', '')}DealAmount`;
		}
	};

	return (
		<Grid container spacing={{ xs: 1, sm: 2 }}>
			{kpiTypes.map((type) => (
				<Grid key={type} size={{ xs: 6, sm: 6, md: 3 }}>
					<DealTableCounterCard
						title={`${type} Deals Amount`}
						countType={getCountType(type)}
						pipelineId={pipelineId}
					/>
				</Grid>
			))}
		</Grid>
	);
};
